export default {
  components: {},
  props: {
    title: { type: String, default: '' },
    tId: { type: String, default: 'tId' }
  },
  data() {
    return {
      loading: false,
      /**
       * @type {import('../../index.vue').IRoleId}
       */
      roleId: this.$parent.roleId || ''
    }
  },
  mounted: function() {},
  methods: {
    handleRowIdx: function(row) {
      let tabType = this.tabConfig.tableType
      console.log('表格配置：', this.tabConfig)
      if (tabType === 'service') {
        console.log('服务单 ID', row.SERVICE_ORDER_ID)
      } else if (tabType === 'work') {
        console.log('工单 ID', row.WORK_ORDER_ID)
      }
    },
    //详情
    detail(row){
      //TODO 一个工单对应多个服务单
      var p2 = {};
      p2["F_WORK_ORDER_ID"] = row["WORK_ORDER_ID"];
      var requestId = "queryServiceOrderTables";
      this.api.queryList(
          'YW_SERVICE_ORDER_V1',
          {p2: p2},
          requestId
      ).then(response => {
          var result = response.result;
          if(result){
            row["YW_SERVICE_ORDER_V1"] = result;
            var componentName = 'allForm-' + row["WORK_ORDER_ID"];
            this.baseComponent.smartLoadComponent('allForm', {title: '工单详情-' + row['WORK_ORDER_NUM'], source: 'viewBoard', formData: row}, {uniqueName: componentName})
          }
      });
    },
    //派单
    dispatch(row){
      Object.keys(row).map(key => {
        if(("WORK_ORDER_ID,WORK_ORDER_CATEGORY").indexOf(key) == -1) {
          delete row[key];
        }
      });
      row.IS_NEW = true;
      row.F_WORK_ORDER_ID = row.WORK_ORDER_ID;
      if(row.WORK_ORDER_CATEGORY == '1') {
        this.baseComponent.smartLoadComponent('siteRequestForm', {serviceRequest: this, tableObj: this.tableObj, editRow: row, type: 'yw', title: '创建现场服务运维单', from: 'dispatchForm'})
      } else {
        this.baseComponent.smartLoadComponent('siteRequestForm', {serviceRequest: this, tableObj: this.tableObj, editRow: row, type: 'gc', title: '创建现场服务工程单', from: 'dispatchForm'})
      }
    },
    //验收
    accept(data){
      var componentName = 'siteAcceptForm-' + data["SERVICE_ORDER_NUM"];
      if(data.WORK_ORDER_CATEGORY == '1'){
        this.baseComponent.smartLoadComponent('siteForm', {title: '验收-' + data['SERVICE_ORDER_NUM'], source: 'workOrder', formData: data, orderType: 'ys', from: 'acceptForm'}, {uniqueName: componentName});
      }else{
        this.baseComponent.smartLoadComponent('siteForm', {title: '验收-' + data['SERVICE_ORDER_NUM'], source: 'workOrder', formData: data, orderType: 'ys', from: 'acceptForm'}, {uniqueName: componentName});
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/viewBoard/components/mixins/comTable.js